// extracted by mini-css-extract-plugin
export var copyableField = "_q2-4";
export var customerBadge = "_q2-0";
export var customerInfoTitle = "_q2-2";
export var details = "_q2-1";
export var dropdownContainer = "_q2-5";
export var dropdownImage = "_q2-6";
export var editAssigneeForm = "_q2-a";
export var editButton = "_q2-3";
export var email = "_q2-7";
export var hidden = "_q2-d";
export var input = "_q2-8";
export var saveButton = "_q2-b";
export var shopifyIcon = "_q2-c";
export var suggestionBadge = "_q2-e";
export var suggestionText = "_q2-f";
export var username = "_q2-9";